import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { OrganizationChartModule } from 'primeng/organizationchart';

import { TreeNode } from 'primeng/api';
@Component({
  selector: 'app-org-chart',
  standalone: true,
  imports: [OrganizationChartModule],
  templateUrl: './org-chart.component.html',
  styleUrl: './org-chart.component.scss'
})
export class OrgChartComponent implements OnInit {

  constructor(private adminService: AdminService) {
  }
  ngOnInit(): void {
    // this.adminService.getOrgChart().subscribe((response) => {
    //   console.log(response);
    // })
  }

  selectedNodes!: TreeNode[];

  data: TreeNode[] = [
    {
      expanded: true,
      type: 'person',
      data: {
        image: 'assets/images/sharjah-airport-logo.png',
        name: 'Amy Elsner',
        title: 'CEO'
      },
      children: [
        {
          expanded: true,
          type: 'person',
          data: {
            image: 'assets/images/sharjah-airport-logo.png',
            name: 'Anna Fali',
            title: 'CMO'
          },
          children: [
            {
              label: 'Sales'
            },
            {
              label: 'Marketing'
            }
          ]
        },
        {
          expanded: true,
          type: 'person',
          data: {
            image: 'assets/images/sharjah-airport-logo.png',
            name: 'Stephen Shaw',
            title: 'CTO'
          },
          children: [
            {
              label: 'Development'
            },
            {
              label: 'UI/UX Design'
            }
          ]
        }
      ]
    }
  ];
}
